export default __webpack_public_path__ + "static/media/lottery-active-m.ef50339c.svg";